// import libaries
import axios from "axios";
// files
import i18n from "../i18n";
import { env } from "../env";
import { LANGUAGE_STORAGE_KEY, normalizeLanguageCode } from "../i18n";

const buildApiUrl = (path) => {
    const rawBase = String(env.REACT_APP_API_URL || "").trim().replace(/\/+$/, "");
    if (!rawBase) {
        return `/api/${path}`;
    }
    return rawBase.endsWith("/api") ? `${rawBase}/${path}` : `${rawBase}/api/${path}`;
};

const mapTranslationsToDictionary = (list, language) => {
    return list.reduce((dictionary, item) => {
        const key = String(item?.key || "").trim();
        if (!key) return dictionary;

        const value = String(item?.value || "").trim();
        const defaultValue = String(item?.defaultvalue || "").trim();

        dictionary[key] = value || defaultValue || key;
        return dictionary;
    }, {});
};

export const loadPublicTranslations = async (lang = "en") => {
    const language = normalizeLanguageCode(lang);
    const cacheKey = `publicTranslations_${language}`;
    const stored = localStorage.getItem(cacheKey);

    if (stored) {
        try {
            const dictionary = JSON.parse(stored);
            i18n.addResourceBundle(language, "translation", dictionary, true, true);
        } catch {
            localStorage.removeItem(cacheKey);
        }
    }

    try {
        const res = await axios.get(
            buildApiUrl("SystemTranslation/GetSystemTranslationList"),
            { params: { language } }
        );

        const list = Array.isArray(res?.data) ? res.data : [];
        const dictionary = mapTranslationsToDictionary(list, language);

        localStorage.setItem(cacheKey, JSON.stringify(dictionary));
        i18n.addResourceBundle(language, "translation", dictionary, true, true);
    } catch (error) {
        console.log("error loading public translations", error);
    } finally {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        await i18n.changeLanguage(language);
    }
};
